import http from 'hub-http/clients/apiClient';
export function getEcosystemDetails(appId) {
  return http.get(`ecosystem/v1/apps/details?appId=${appId}`);
}